export default __webpack_public_path__ + "static/media/jump.f5175184.wav";